export default __webpack_public_path__ + "static/media/love.5c0bbf7c.svg";